
/**
 * Created by nijin on 5/1/17.
 */
import {Routes, RouterModule} from "@angular/router";
import {AccountComponent} from "./account.component";
import {NgModule} from "@angular/core";
import {ProfileComponent} from "./profile/profile.component";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {PlansComponent} from "./plans/plans.component";
import {BillingComponent} from "./billing/billing.component";
import {ApiKeyComponent} from "./api-key/api-key.component";
import {BlankStateComponent} from "./api-key/sub/blank-state.component";
import {NotifierComponent} from "./api-key/sub/notifier.component";
import {DisplayKeyComponent} from "./api-key/sub/display-key.component";
import {RemoveIPConfirmationComponent} from "./api-key/modal/remove.ip.confirmation";
import {RegenerateKeyConfirmationComponent} from "./api-key/modal/regenerate.key.confirmtaion";
import {DeleteKeyConfirmationComponent} from "./api-key/modal/delete.key.confirmation";
import {ViewKeyComponent} from "./api-key/modal/view.key";
import {GLOBAL_CONSTANTS} from "../global/global.constants";

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      { path: '', component: ProfileComponent  },
      { path: 'password', component: ChangePasswordComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.PASSWORD}  },
      { path: 'api-key', component: ApiKeyComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.API_KEY}   },
      { path: 'plans', component: PlansComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.PRICING }},
      { path: 'bills', component: BillingComponent  },
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [],
})
export class AccountRoutingModule { }

export let ROUTED_COMPONENTS = [
  ProfileComponent,
  ChangePasswordComponent,
  PlansComponent,
  BillingComponent,
  BlankStateComponent,
  ApiKeyComponent,
  NotifierComponent,
  DisplayKeyComponent,
  RemoveIPConfirmationComponent,
  RegenerateKeyConfirmationComponent,
  DeleteKeyConfirmationComponent,
  ViewKeyComponent
]



// WEBPACK FOOTER //
// ./src/app/accounts/account.routing.module.ts